import React from 'react';

const LoginArrowUp = () => {
	return (
		<div
			className="
      vtex-login-2-x-arrowUp arrowUp absolute top-0 right-0 mr3 shadow-3 bg-base rotate-45 h2 w2"
		></div>
	);
};

export default LoginArrowUp;
